import React from 'react';
import {Collapse} from 'antd';
import {FaqItem} from '../../pages/site/site.types';

interface FaqListProps {
    items: FaqItem[];
}

const FaqList: React.FC<FaqListProps> = ({items}) => {
    return (
        <Collapse
            ghost
            items={items.map(item => ({
                key: item.question,
                label: item.question,
                children: <p style={{color: 'var(--site-text-muted)', lineHeight: 1.8}}>{item.answer}</p>
            }))}
        />
    );
};

export default FaqList;
